import React, {useContext} from 'react';
import Input from 'epic-diesel-form/src/components/form/Input';
import Select from 'epic-diesel-form/src/components/form/Select';
import {Message, getMessage} from '../../../common/Message';
import {ApplicationContext} from '../../../../hocs/WithApplicationView';

//@ts-ignore
import styles from './GuardianSection.pcss';

export interface GuardianSectionProps {
    messages: Record<string, string>;
    trigger: (key: string, value: string) => void;
    form: any;
}

const GuardianSection: React.FC<GuardianSectionProps> = ({messages, trigger, form}) => {
    const {schema} = useContext(ApplicationContext);
    const options = [
        {
            value: '',
            label: `${getMessage(messages, 'epic.affiliate.common.title.v2')} *`
        },
        {
            value: 'father',
            label: getMessage(messages, 'epic.affiliate.signup.guardian.relationship.father')
        },
        {
            value: 'mother',
            label: getMessage(messages, 'epic.affiliate.signup.guardian.relationship.mother')
        },
        {
            value: 'other',
            label: getMessage(messages, 'epic.affiliate.signup.guardian.relationship.other')
        }
    ];

    const onChange = event => {
        const {name, value} = event.target;
        trigger(name, value);
    };

    return (
        <>
            <h2>
                <Message code="epic.affiliate.guardian.region.header" />
                {' *'}
            </h2>
            <p>
                <Message code="epic.affiliate.guardian.region.text.v2" />
            </p>

            <div className={styles.fields}>
                <div className={styles.stateCityContainer}>
                    <div className={styles.stateContainer}>
                        <Input
                            required
                            name={schema.guardianFirstName.identifier}
                            value={form.firstName}
                            placeholder={schema.guardianFirstName.display.text}
                            validations={schema.guardianFirstName.validations}
                            validationErrors={schema.guardianFirstName.validationMessages}
                            onChange={onChange}
                        />
                    </div>
                    <div className={styles.stateContainer}>
                        <Input
                            required
                            name={schema.guardianLastName.identifier}
                            value={form.lastName}
                            placeholder={schema.guardianLastName.display.text}
                            validations={schema.guardianLastName.validations}
                            validationErrors={schema.guardianLastName.validationMessages}
                            onChange={onChange}
                        />
                    </div>
                    <div className={styles.stateContainer}>
                        <Select
                            required
                            name={schema.guardianRelationship.identifier}
                            className={styles.dropdown}
                            value={form.relationship || ''}
                            validations={schema.guardianRelationship.validations}
                            validationErrors={schema.guardianRelationship.validationMessages}
                            onChange={trigger}
                            options={options}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default GuardianSection;
